import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Input from "@material-ui/core/Input";
import Collapse from "@material-ui/core/Collapse";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import ExpertQuestionTemplateSection from "./ExpertQuestionTemplateSection";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import KpsTextField from "../KpsTextField";
import { DialogContent, DialogActions } from "@material-ui/core";
const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});
class AddExpertQuestionTemplateSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.edit
        ? this.props.selected
        : {
            label: "",
            type: null,
            values: [],
            default: "",
            expandedFrom: [],
            parentId: this.props.selected ? this.props.selected.id : null,
            id: this.props.currentId + 1,
            queryValue: null,
            value: null,
          },
      openAddSection: false,
      valueToBeAdded: "",
    };
  }
  handleValueDelete = (index) => {
    let tempValues = [...this.state.data.values];
    tempValues.splice(index, 1);
    this.setState({ data: { ...this.state.data, values: tempValues } });
  };
  onDataConfirmed = (data) => {
    this.setState({
      data: {
        ...this.state.data,
        expandedFrom: [...this.state.data.expandedFrom, data],
      },
    });
  };
  onQueryChange = (event) => {
    this.setState({
      data: { ...this.state.data, queryValue: event.target.value },
    });
  };
  render() {
    const { classes, t } = this.props;
    return (
      <>
        <DialogTitle>
          {this.props.edit ? (
            <Trans i18nKey="edit_section" />
          ) : (
            <Trans i18nKey="create_section" />
          )}
        </DialogTitle>
        <DialogContent style={{ display: "flex", flexDirection: "column" }}>
          <Typography>{t("create_section_subheader")}</Typography>
          {this.props.selected &&
            (this.props.selected.type === "Radio" ||
            this.props.selected.type === "Select" ? (
              <FormControl component="fieldset" className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">
                  <Trans i18nKey="on_the_value" />
                </InputLabel>
                <Select
                  value={this.state.data.queryValue}
                  label={<Trans i18nKey="query_value" />}
                  onChange={this.onQueryChange}
                  required
                  id="query-value"
                >
                  {this.props.selected.values.map((value) => (
                    <MenuItem value={value}>{value}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              this.props.selected.type === "Checkbox" && (
                <FormControl
                  component="fieldset"
                  className={classes.formControl}
                >
                  <Select
                    value={this.state.data.queryValue}
                    label={<Trans i18nKey="query_value" />}
                    onChange={this.onQueryChange}
                  >
                    <MenuItem value={true}>
                      <Trans i18nKey="checked" />
                    </MenuItem>
                    <MenuItem value={false}>
                      <Trans i18nKey="unchecked" />
                    </MenuItem>
                  </Select>
                </FormControl>
              )
            ))}
          <Collapse
            in={
              !this.props.selected ||
              (this.state.data.queryValue != null &&
                this.props.selected != null) ||
              this.props.edit
            }
            timeout="auto"
            unmountOnExit
          >
            {(!this.props.selected ||
              (this.state.data.queryValue != null &&
                this.props.selected != null) ||
              this.props.edit) && (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <FormControl
                  component="fieldset"
                  className={classes.formControl}
                >
                  <KpsTextField
                    labelId="demo-simple-select-label"
                    onChange={(e) =>
                      this.setState({
                        data: { ...this.state.data, label: e.target.value },
                      })
                    }
                    value={this.state.data.label}
                    label={<Trans i18nKey="global_label" />}
                    id="section-label"
                    required
                  />
                </FormControl>
                <FormControl
                  component="fieldset"
                  className={classes.formControl}
                  required
                >
                  <InputLabel id="demo-simple-select-label">
                    <Trans i18nKey="input_type" />
                  </InputLabel>
                  <Select
                    value={this.state.data.type}
                    label={<Trans i18nKey="global_type" />}
                    required
                    id="input-type"
                    onChange={(event) =>
                      this.setState({
                        data: { ...this.state.data, type: event.target.value },
                      })
                    }
                  >
                    <MenuItem value={"TextInput"}>
                      <Trans i18nKey="text_input" />
                    </MenuItem>
                    <MenuItem value={"TextArea"}>
                      <Trans i18nKey="text_area" />
                    </MenuItem>
                    <MenuItem value={"Select"}>
                      <Trans i18nKey="select" />
                    </MenuItem>
                    <MenuItem value={"Radio"}>
                      <Trans i18nKey="radio" />
                    </MenuItem>
                    <MenuItem value={"Checkbox"}>
                      <Trans i18nKey="checkbox" />
                    </MenuItem>
                  </Select>
                </FormControl>
                {this.state.data.type === "Select" ||
                this.state.data.type === "Radio" ? (
                  <>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <Typography variant="subtitle1">
                        {t("create_section_options")}
                      </Typography>
                      <div>
                        {this.state.data.values.length > 0 ? (
                          <>
                            {this.state.data.values.map((value, index) => (
                              <Chip
                                label={value}
                                style={{ margin: 2 }}
                                onDelete={() => this.handleValueDelete(index)}
                              />
                            ))}
                          </>
                        ) : (
                          <Typography variant="subtitle2">
                            {t("create_section_no_options")}
                          </Typography>
                        )}
                      </div>
                    </FormControl>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <KpsTextField
                        id="option-input"
                        onChange={(e) =>
                          this.setState({ valueToBeAdded: e.target.value })
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.setState({
                              data: {
                                ...this.state.data,
                                values: [
                                  ...this.state.data.values,
                                  this.state.valueToBeAdded,
                                ],
                              },
                              valueToBeAdded: "",
                            });
                          }
                        }}
                        value={this.state.valueToBeAdded}
                        label={t("create_section_type_an_option")}
                        helperText={t(
                          "create_section_type_an_option_helper_text"
                        )}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                color="primary"
                                onClick={() =>
                                  this.setState({
                                    data: {
                                      ...this.state.data,
                                      values: [
                                        ...this.state.data.values,
                                        this.state.valueToBeAdded,
                                      ],
                                    },
                                    valueToBeAdded: "",
                                  })
                                }
                              >
                                <AddIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </FormControl>
                  </>
                ) : (
                  (this.state.data.type === "TextArea" ||
                    this.state.data.type === "TextInput") && (
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <KpsTextField
                        className={classes.textField}
                        onChange={(e) =>
                          this.setState({
                            data: {
                              ...this.state.data,
                              default: e.target.value,
                            },
                          })
                        }
                        value={this.state.data.default}
                        label={<Trans i18nKey="default_text" />}
                      />
                    </FormControl>
                  )
                )}
              </div>
            )}
          </Collapse>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} color="primary">
            <Trans i18nKey="global_cancel" />
          </Button>
          <Button
            onClick={() =>
              this.props.onDataConfirmed(this.state.data, this.props.edit)
            }
            color="primary"
            disabled={!this.state.data.type || !this.state.data.label}
            id="create-section-button"
          >
            <Trans i18nKey="global_create" />
          </Button>
        </DialogActions>
      </>
    );
  }
}
export default withTranslation()(
  withStyles(styles)(AddExpertQuestionTemplateSection)
);
